import moment from "moment-timezone";

var currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

function getTimezone(){
    var oDate = new Date(); 
    var nTimezone = -oDate.getTimezoneOffset() / 60; 
    alert(nTimezone.toFixed(2))
}
if(!currentTimezone.includes("/")){
    // currentTimezone = getTimezone();
    currentTimezone = moment.tz.guess();
};

export const toCurrentTime = (time,tz)=>{
    console.log("toCurrentTime",time,tz);
    if(!time){
        return "";
    }
    if(!tz){
        return time;
    };
    var t1 = moment.tz(time,tz);
    return t1.clone().tz(currentTimezone).format("YYYY-MM-DD HH:mm:ss");
};